/** @module applaunchUtils */

import config from '@bedrock-rdk/config';

export const getApplaunchConfig = localId => ({
  app: config.app,
  platform: config.platformCode,
  localDeviceId: localId,
  customizer: config.customizer,
  ...config.fido.applaunch,
});
